import { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

import useIsFirstRender from '@/hooks/useIsFirstRender';
import useStateHandler from '@/hooks/useStateHandler';
import SuarteName from '@/shared-components/icons/components/public/SuarteName';
import XIcon from '@/shared-components/icons/components/public/XIcon';

import PopupToBottomSheet from '../components/PopupToBottomSheet';

import AuthForgotPassword from './components/AuthForgotPassword';
import AuthLogin from './components/AuthLogin';
import AuthNavigation from './components/AuthNavigation';
import AuthRegularSignup from './components/AuthRegularSignup';
import AuthSignupSelector from './components/AuthSignupSelector';
import AuthArtistSignup from './auth-artist-signup';

import './index.css';

function AuthPopupContent({ close, page = "sign-up", onTabChange }) {
  const [currentPage, setCurrentPage] = useState(page);

  useEffect(() => {
    onTabChange(currentPage);
  }, []);

  const changeTab = (page) => {
    setCurrentPage(page);
    onTabChange(page);
  };

  return (
    <>
      <div className="auth-popup-content">
        <div className="auth-popup-content__header">
          <SuarteName className="auth-popup-content__header-suarte-name"/>
          <XIcon className="auth-popup-content__header-close" onClick={close}/>
        </div>

        <AuthNavigation currentPage={currentPage} setCurrentPage={changeTab}/>

        <div className="auth-popup-content__wrap remove-scrollbar">
          {
            currentPage === "login" ? 
              <AuthLogin setCurrentPage={changeTab} close={close}/>
              : currentPage === "forgot" ? 
                <AuthForgotPassword/>
                : currentPage === "signup-selector" ? 
                  <AuthSignupSelector setCurrentPage={changeTab}/>
                  : currentPage === "sign-up" ? 
                    <AuthRegularSignup close={close}/>
                    :
                    <AuthArtistSignup setCurrentPage={changeTab} close={close}/>
          }
        </div>
      </div>
    </>
  );
}

export default function AuthPopup() {
  const { state, stateHandler } = useStateHandler();
  const isFirstRender = useIsFirstRender();
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    if(!isFirstRender && state.action_denied === "USER_ACCOUNT_REQUIRED") {
      stateHandler.set("action_denied", null); /** Closes the popup in case we navigated to another page */
    }
    
  }, [location.pathname]);

  function closeAuthSection(redirect = true) {
    stateHandler.set("action_denied", null);
    stateHandler.set("showAuthPopup", undefined);

    // if we are in login or sign-up page and we close the modal and redirect to main page
    if(redirect && (location.pathname === "/login" || location.pathname === "/sign-up")) {
      navigate("/", { replace: true });
    }
  }

  useEffect(() => {
    if(state.user_session) {
      closeAuthSection(false);
    }
  }, [state.user_session]);

  const authPage = state.showAuthPopup || undefined;

  const isHome = (page) => page === "/" || page === "/login" || page === "/sign-up";

  const onTabChange = (tab) => {
    if(isHome(location.pathname)) {
      // if we are in one of this pages, we redirect to the new page
      if(tab === "sign-up" || tab === "login") {
        navigate(tab, { replace: true });
      }
    }
  };

  return (
    <>
      <PopupToBottomSheet 
        className="auth-popup-container" 
        open={state.action_denied === "USER_ACCOUNT_REQUIRED" || !!state.showAuthPopup} 
        close={closeAuthSection} 
        popupOptions={{ opacity: true }}
      >
        <AuthPopupContent close={closeAuthSection} page={authPage} onTabChange={onTabChange} />
      </PopupToBottomSheet>
    </>
  );
}
